import * as React from 'react';
import { cn } from '../../../utils';
import { ImagePlaceholder } from '../../atoms/icons';
import Picture from '../picture/picture';

export interface ICoverImageProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
	src?: string | null;
	alt: string;
}

export const CoverImage = ({ src, alt, className, ...restProps }: ICoverImageProps) => {
	const [hasError, setHasError] = React.useState(false);

	React.useEffect(() => setHasError(false), [src]);

	return (
		<div
			className={cn(
				'relative h-[28rem] w-[28rem] shrink-0 rounded-[0.7rem] border border-dashed border-borderPrimary shadow-card',
				className
			)}
			data-testid="cover-image"
			{...restProps}
		>
			{src && !hasError ? (
				<Picture
					path={src}
					alt={alt}
					className="h-full w-full rounded-[0.7rem] object-cover"
					data-testid="cover-image-content"
					onError={() => setHasError(true)}
				/>
			) : (
				<ImagePlaceholder
					className="absolute top-[20%] left-[20%] h-[15rem] w-[15rem] text-secondary"
					data-testid="cover-image-placeholder"
					aria-label={alt}
				/>
			)}
		</div>
	);
};
